'use strict';

export default ($filter, $sce, userModel) => {
  'ngInject';

  const bookingDateFilter = $filter('bookingDate');
  const translateFilter = $filter('translate');
  const priceFilter = $filter('price');

  return (booking) => {
    var output = '';
    var price;

    if (booking) {
      output += bookingDateFilter(booking.date) + '&nbsp;';

      price = (userModel.item.id === booking.guideId) ? booking.guidePriceInfo : booking.guestPriceInfo;
      output += `(${priceFilter(price.amount, price.currency, 0)}&nbsp;`;
      output += translateFilter('BOOKING_DURATION', { HOURS: booking.hours }) + ')';
    }

    return $sce.trustAsHtml(output);
  };
};



// WEBPACK FOOTER //
// ./app/src/filters/booking.filter.js